import React from "react";
import {useFirebaseState} from "../firebase/firebaseContext";
import {useIsInstructorOrAdmin} from "../firebase/useIsInstructorOrAdmin";
import {InstructorProfile} from "./InstructorProfile";
import {UnauthorizedAccess} from "../app/UnauthorizedAccess";

export const InstructorProfilePage = () => {
    const {auth} = useFirebaseState();
    const instructorOrAdmin = useIsInstructorOrAdmin();

    if (!auth || !auth.currentUser || !instructorOrAdmin) {
        return <UnauthorizedAccess requiredRole="kursholder" />;
    }

    return (
        <InstructorProfile
            userId={auth.currentUser.uid}
        />
    );
};